import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Modal from 'components/Modal/Modal';
import { BUTTON_VARIANT } from 'constants/interfaces';

import FileUpload from '../../../../../components/FileUpload/FileUpload';
import Textarea from '../../../../../components/Textarea/Textarea';
import { COMMENT } from '../../../../../constants/formFields';
import { DESCRIPTION_LENGTH } from '../../../../../constants/general';

import type { ReactElement } from 'react';
import type { IMAIroQuestionsFinishModal } from '../../interfaces/IMAIroQuestionsFinishModal';

import styles from '../../../MaterialAssessmentSurveyAnswer/scss/SurveyAnswerQuestion.module.scss';

function MAIROQuestionFinishModal({
  control,
  open,
  onOpenFinishModal,
  onFinish,
  handleFileUpload,
  attachmentsFiles,
  handleAttachmentsChange,
}: IMAIroQuestionsFinishModal): ReactElement {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      title={t('materialityAssessment.finishModalTitle')}
      description={t('materialityAssessment.finishModalSubTitle')}
      confirmTitle={t('common.finish&Submit', 'Finish & Submit')}
      closeTitle={t('common.cancel', 'Cancel')}
      confirmVariant={BUTTON_VARIANT.primary}
      onConfirm={() => {
        onOpenFinishModal(false);
        onFinish();
      }}
      onReject={() => onOpenFinishModal(false)}
      onClose={() => onOpenFinishModal(false)}
    >
      <Controller
        key={COMMENT}
        control={control}
        name={COMMENT}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <Textarea
            name={COMMENT}
            value={value || ''}
            label={t('materialityAssessment.comment')}
            error={error?.message}
            className={styles.textField}
            placeholder={t('materialityAssessment.placeholder.enterYourAnswer')}
            charactersLimit={DESCRIPTION_LENGTH}
            onChange={(e) => onChange(e.target.value.slice(0, DESCRIPTION_LENGTH))}
          />
        )}
      />
      <div className={styles.attachment}>
        <FileUpload
          attachmentsFiles={attachmentsFiles}
          onAttachmentsChange={handleAttachmentsChange}
          onFileUpload={handleFileUpload}
          label={t('taskManagement.fields.attachments')}
          placeholder={t('taskManagement.fields.attachFile')}
        />
      </div>
    </Modal>
  );
}

export default MAIROQuestionFinishModal;
